import React, { useState } from 'react';

function FormField({ field, value, onChange, error, branding, isDarkMode, theme }) {
  const [isFocused, setIsFocused] = useState(false);

  // Fallback theme if not provided
  const t = theme || {
    inputBg: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#ffffff',
    inputBorder: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.15)',
    inputText: isDarkMode ? '#ffffff' : '#1a1a1a',
    text: isDarkMode ? '#ffffff' : '#1a1a1a',
    textSecondary: isDarkMode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.7)',
  };

  const inputStyles = {
    width: '100%',
    padding: '14px 16px',
    backgroundColor: t.inputBg,
    border: `1px solid ${error ? '#ef4444' : isFocused ? branding.primaryColor : t.inputBorder}`,
    borderRadius: '10px',
    fontSize: '15px',
    fontWeight: '400',
    color: t.inputText,
    transition: 'all 0.2s ease',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit'
  };

  const renderInput = () => {
    const baseProps = {
      id: field.id,
      value: value || '',
      onChange: (e) => onChange(field.id, e.target.value),
      onFocus: () => setIsFocused(true),
      onBlur: () => setIsFocused(false),
      placeholder: field.placeholder,
      style: inputStyles
    };

    switch (field.type) {
      case 'select':
        return (
          <select 
            {...baseProps}
            style={{
              ...inputStyles,
              appearance: 'none',
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='${isDarkMode ? '%23888' : '%23666'}' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 14px center',
              paddingRight: '40px',
              cursor: 'pointer'
            }}
          >
            <option value="" style={{ backgroundColor: isDarkMode ? '#1a1a1a' : '#fff', color: isDarkMode ? '#999' : '#666' }}>
              Select an option
            </option>
            {field.options.map(option => (
              <option 
                key={option} 
                value={option}
                style={{ backgroundColor: isDarkMode ? '#1a1a1a' : '#fff', color: isDarkMode ? '#fff' : '#1a1a1a' }}
              >
                {option}
              </option>
            ))}
          </select>
        );
        
      case 'textarea':
        return (
          <textarea
            {...baseProps}
            rows={4}
            style={{ 
              ...inputStyles, 
              resize: 'vertical',
              minHeight: '100px'
            }}
          />
        );
        
      case 'number':
        return (
          <input
            {...baseProps}
            type="number"
          />
        );
        
      case 'email':
        return (
          <input
            {...baseProps}
            type="email"
          />
        );
        
      default:
        return (
          <input
            {...baseProps}
            type="text"
          />
        );
    }
  };

  return (
    <div>
      <label 
        htmlFor={field.id}
        style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: '500',
          color: t.textSecondary,
          fontSize: '14px',
          letterSpacing: '-0.01em'
        }}
      >
        {field.label}
        {field.required && (
          <span style={{ 
            color: branding.primaryColor, 
            marginLeft: '4px'
          }}>*</span>
        )}
      </label>
      
      {renderInput()}
      
      {error && (
        <p style={{
          color: '#ef4444',
          fontSize: '13px',
          marginTop: '6px',
          marginBottom: 0
        }}>
          {error}
        </p>
      )}
    </div>
  );
}

export default FormField;
